import React from 'react';

export const LazyAssessmentPage = React.lazy(() =>
  import('./AssessmentPage').then((module) => ({
    default: module.AssessmentPage,
  }))
);
